export default [
  {
    path: 'kartu-stok',
    name: 'report stock card',
    component: () => import('@/views/app/report-stock/stock-card/page-list.vue'),
    meta: { title: 'Laporan Kartu Stok' },
  },
  {
    path: 'nilai-inventaris',
    name: 'report stock value',
    component: () => import('@/views/app/report-stock/inventory-value/page-list.vue'),
    meta: { title: 'Laporan Nilai Inventaris' },
  },
  {
    path: 'rekap',
    name: 'report stock summary',
    component: () => import('@/views/app/report-stock/summary/page-list.vue'),
    meta: { title: 'Laporan Rekap Stok' },
  },
  {
    path: 'rekap-nilai',
    name: 'report stock summary value',
    component: () => import('@/views/app/report-stock/summary-value/page-list.vue'),
    meta: { title: 'Laporan Rekap Stok Nilai' },
  },
  {
    path: 'mutasi-barang',
    name: 'report stock move order',
    component: () => import('@/views/app/report-stock/move-order/page-list.vue'),
    meta: { title: 'Laporan Stok Mutasi Barang' },
  },
  {
    path: 'penyesuaian-stok',
    name: 'report stock adjustment',
    component: () => import('@/views/app/report-stock/adjustment/page-list.vue'),
    meta: { title: 'Laporan Penyesuaian Stok' },
  },
  {
    path: 'retur-jual',
    name: 'report stock return sale',
    component: () => import('@/views/app/report-stock/sale-return/page-list.vue'),
    meta: { title: 'Laporan Stok Retur Jual' },
  },
  {
    path: 'retur-beli',
    name: 'report stock return purchase',
    component: () => import('@/views/app/report-stock/purchase-return/page-list.vue'),
    meta: { title: 'Laporan Stok Retur Beli' },
  },
]
